export default "__VITE_ASSET__SBCI81tD__"